import { Component, OnInit, HostBinding, EventEmitter, Output, Input, ViewChild, TemplateRef, Inject, Injector, Optional, ChangeDetectorRef, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { AnonymousSet } from './anonymous-set.entity';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Component({
  selector: 'lib-anonymous-set',
  templateUrl: './anonymous-set.component.html',
  styleUrls: ['./anonymous-set.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class AnonymousSetComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input() set value(data: AnonymousSet) {
    this.anonymousSet.isAnonymity = data.isAnonymity || false;
    this.anonymousSet.anonymous = data.anonymous || this.localePipe.transform('component.anonymousSet.approver');
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  anonymousSet: AnonymousSet = new AnonymousSet();
  modalConfig = {
    title: this.localePipe.transform('component.anonymousSet.anonymousOpt'),
    width: 450,
    height: 360,
    showButtons: true
  };
  constructor(
    private injector: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }
  clickOK() {
    const object = { value: this.anonymousSet, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }
}

export class AnonymousSetConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && data.isAnonymity) {
      return this.localePipe.transform("component.anonymousSet.set");
    } else {
      return this.localePipe.transform("component.anonymousSet.notSet");
    }
  }
}
